export default __webpack_public_path__ + "static/meshery-logo-d60dfbed19367cfaeef5ed364381cd74.webp";